module.exports = __webpack_public_path__ + "img/refrigerator.a5726a9d.svg";